module.exports = __webpack_public_path__ + "img/dots.6d8866ff.svg";